(function(){
  'use strict';
  /* Sliding indicator for every .bae-toggle group.
     Pill mode (default): positions the Sol Green pill via --tw/--tx.
     Tab mode (.bae-toggle--tabs): positions the .bae-toggle__slider line
     (the span itself is created by initToggleSlide in baesole.js). */
  function move(group){
    var active = group.querySelector('.bae-toggle__btn.is-active');
    if(!active) return;
    var pad = 3;
    group.style.setProperty('--tw', active.offsetWidth + 'px');
    group.style.setProperty('--tx', (active.offsetLeft - pad) + 'px');
    var sl = group.querySelector('.bae-toggle__slider');
    if(sl){ sl.style.left = active.offsetLeft + 'px'; sl.style.width = active.offsetWidth + 'px'; }
  }
  function init(){
    document.querySelectorAll('.bae-toggle').forEach(function(g){
      move(g);
      g.addEventListener('click', function(e){
        if(e.target.closest('.bae-toggle__btn')) setTimeout(function(){ move(g); }, 0);
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('resize', function(){
    document.querySelectorAll('.bae-toggle').forEach(move);
  });
  window.BaeToggle = { sync: function(){ document.querySelectorAll('.bae-toggle').forEach(move); } };
})();
